
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Bestpicnicspotnearnagpur() {



  const cardData =
  {
    keyword: ' Best Picnic Spot Near Nagpur',
    heading:  'Woodland Escape: Best Picnic Spot Near Nagpur',
    headingDescription: 'Best Picnic Spot Near Nagpur offers the perfect blend of nature, relaxation, and recreation just a short drive from the city. Surrounded by serene lakes, lush gardens, and refreshing greenery, these picnic destinations are ideal for families, friends, and corporate groups seeking a quick escape. Popular spots like Ambazari Lake, Futala Lake, and Khindsi Lake provide boating, scenic walks, and peaceful corners to unwind. Whether it’s a fun-filled day with kids, a romantic outing, or a group excursion, the picnic spots near Nagpur promise memorable moments amidst natural beauty and tranquil surroundings',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



   "services": [
    {
      "name": "Best Picnic Spot Near Nagpur",
      "description": "Woodland Escape Resort is one of the best picnic spots near Nagpur, offering a perfect blend of nature, comfort, and fun-filled outdoor experiences. Spend the day surrounded by lush greenery, tranquil ponds, and scenic landscapes. Enjoy outdoor games, nature walks, and delicious food prepared with fresh ingredients. Whether you’re with friends, family, or colleagues, it’s the ideal destination for relaxation and recreation away from the city buzz."
    },
    {
      "name": "Nagpur Top Picnic Places",
      "description": "If you’re searching for the top picnic places near Nagpur, Woodland Escape Resort stands out for its serene setting and wide range of activities. Visitors can relax under shady trees, take part in team games, explore nature trails, or simply unwind by the lake. With comfortable amenities and beautiful surroundings, it’s a perfect retreat for all age groups looking for a joyful outdoor experience."
    },
    {
      "name": "Nagpur Picnic Locations",
      "description": "Among Nagpur’s popular picnic locations, Woodland Escape Resort offers an unforgettable day in the lap of nature. The resort features vast open lawns, picnic areas, gazebos, and play zones for children. Guests can enjoy guided walks, photography, and traditional local meals, making it a wholesome and memorable picnic experience."
    },
    {
      "name": "Family Picnic Spot Nagpur",
      "description": "For families in and around Nagpur, Woodland Escape Resort is a wonderful picnic spot that promises fun, bonding, and relaxation. With safe play zones for kids, shaded seating areas, and family-friendly activities like cycling and outdoor games, it provides the perfect atmosphere for quality family time amid peaceful natural surroundings."
    },
    {
      "name": "Affordable Picnic Spot Nagpur",
      "description": "Woodland Escape Resort is an affordable picnic spot near Nagpur that doesn’t compromise on experience. Guests can enjoy scenic views, comfortable amenities, delicious meals, and outdoor entertainment—all at pocket-friendly rates. It’s a perfect destination for schools, colleges, and small groups looking for a cost-effective yet enjoyable outing."
    },
    {
      "name": "Nagpur Weekend Picnic",
      "description": "Make your weekends more exciting with a day at Woodland Escape Resort, one of the best weekend picnic destinations near Nagpur. Reconnect with nature, indulge in outdoor sports, and enjoy freshly cooked meals in a peaceful environment. Whether you’re planning a quick getaway or a full-day picnic, the resort guarantees a rejuvenating experience."
    },
    {
      "name": "Nagpur Nature Picnic Spot",
      "description": "Surrounded by lush greenery, Woodland Escape Resort is a paradise for nature lovers seeking a peaceful picnic spot near Nagpur. Guests can explore scenic trails, enjoy bird watching, or simply relax under the shade of tall trees. The resort’s eco-friendly setting makes it an ideal choice for those who want to experience nature up close."
    },
    {
      "name": "Nagpur Outdoor Picnic Place",
      "description": "For an adventurous outdoor picnic near Nagpur, Woodland Escape Resort offers everything you need. With vast open spaces for games, picnic areas with seating, and natural attractions all around, guests can spend the day playing, relaxing, and reconnecting with nature. It’s the perfect outdoor destination for groups of all sizes."
    },
    {
      "name": "Nagpur Scenic Picnic Spot",
      "description": "Woodland Escape Resort is one of the most scenic picnic spots near Nagpur, featuring picturesque landscapes, open meadows, and a calm countryside vibe. The resort offers a great backdrop for photography and relaxation while guests enjoy delicious food, fresh air, and the soothing sounds of nature."
    },
    {
      "name": "Nagpur Park Picnic Spot",
      "description": "If you enjoy the atmosphere of a park but want something more exclusive, Woodland Escape Resort provides the ideal park-style picnic experience. With manicured gardens, shaded trees, and picnic tables, it combines the charm of a public park with the comfort and privacy of a resort."
    },
    {
      "name": "Nagpur Hill Picnic Spot",
      "description": "Located near the natural elevations around Nagpur, Woodland Escape Resort offers a hill picnic experience with stunning views and fresh air. Spend your day exploring gentle trails, enjoying panoramic vistas, and relaxing in nature’s lap. Perfect for couples and groups looking for a peaceful yet scenic outing."
    },
    {
      "name": "Nagpur Riverside Picnic",
      "description": "For those who love the sound of flowing water, Woodland Escape Resort offers a serene riverside picnic experience near Nagpur. Sit by the riverside, enjoy your meal with a view, and take part in outdoor fun like nature walks and group games. It’s a perfect combination of peace, beauty, and recreation."
    },
    {
      "name": "Nagpur Garden Picnic",
      "description": "Enjoy a refreshing garden picnic at Woodland Escape Resort, surrounded by flowering plants, shady trees, and well-maintained lawns. Guests can spread out picnic blankets, enjoy packed meals or resort-cooked dishes, and relax in a natural, beautifully landscaped environment. Ideal for families and couples."
    },
    {
      "name": "Nagpur Picnic Spot Booking",
      "description": "Book your perfect picnic day at Woodland Escape Resort near Nagpur easily. Whether it’s a family event, school trip, or corporate picnic, the resort offers flexible booking packages with meals, games, and amenities included. Advance booking ensures a smooth and organized experience for all visitors."
    },
    {
      "name": "Nagpur Picnic Tour",
      "description": "Experience a complete picnic tour near Nagpur with Woodland Escape Resort. Begin with a nature walk, enjoy interactive outdoor games, have a traditional meal, and end the day relaxing by the scenic countryside. The resort’s picnic tour is designed for fun, relaxation, and reconnecting with nature."
    }
  ],
  "tableData": [
    ["- Best Picnic Spot Near Nagpur", "- Nagpur Top Picnic Places"],
    ["- Nagpur Picnic Locations", "- Family Picnic Spot Nagpur"],
    ["- Affordable Picnic Spot Nagpur", "- Nagpur Weekend Picnic"],
    ["- Nagpur Nature Picnic Spot", "- Nagpur Outdoor Picnic Place"],
    ["- Nagpur Scenic Picnic Spot", "- Nagpur Park Picnic Spot"],
    ["- Nagpur Hill Picnic Spot", "- Nagpur Riverside Picnic"],
    ["- Nagpur Garden Picnic", "- Nagpur Picnic Spot Booking"],
    ["- Nagpur Picnic Tour", ""]
  ],
  



whychoose: [
  {
    "WhyChooseheading": "Best Picnic Spot Near Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort stands out as one of the best picnic spots near Nagpur, offering a perfect blend of nature, fun, and relaxation. Set amidst dense forests and scenic landscapes, the resort provides a refreshing escape from city life. It’s an ideal destination for families, school groups, and friends looking to enjoy a day surrounded by greenery, laughter, and natural beauty."
  },
  {
    "WhyChooseheading": "Tranquil Forest Surroundings",
    "WhyChoosedescription": "Nestled deep within a lush forest, Woodland Escape Resort offers a serene environment where you can unwind and reconnect with nature. The soothing sounds of rustling leaves, chirping birds, and gentle breezes make it a peaceful paradise for anyone seeking calmness and relaxation away from the city noise."
  },
  {
    "WhyChooseheading": "Spacious Picnic Areas and Comfort Zones",
    "WhyChoosedescription": "Our resort features wide open lawns, shaded sit-out zones, and cozy forest-view spots perfect for setting up your picnic. Whether you prefer lounging under the trees, enjoying outdoor games, or relaxing with a good meal, our comfortable and well-maintained areas ensure a joyful picnic experience for everyone."
  },
  {
    "WhyChooseheading": "Exciting Outdoor Activities",
    "WhyChoosedescription": "At Woodland Escape Resort, your picnic can be as adventurous as you like! Enjoy activities such as nature trails, zip-lining, cycling, archery, and forest walks. For those who prefer something more relaxed, there are options like bird watching, pondside lounging, or simply enjoying a peaceful meal in the lap of nature."
  },
  {
    "WhyChooseheading": "Delicious Local and Farm-Fresh Meals",
    "WhyChoosedescription": "Savor the taste of delicious, freshly prepared meals made from locally sourced ingredients. Our in-house kitchen offers traditional regional dishes and picnic-style snacks that enhance the outdoor experience. Each meal is cooked with care, ensuring a healthy and flavorful addition to your forest picnic day."
  },
  {
    "WhyChooseheading": "Perfect for Families, Friends, and Groups",
    "WhyChoosedescription": "Woodland Escape Resort is the perfect venue for families, school picnics, and group outings. With plenty of space for activities, fun games, and relaxation, it offers an ideal setting to bond with loved ones and make lasting memories surrounded by nature’s beauty."
  },
  {
    "WhyChooseheading": "Easily Accessible from Nagpur",
    "WhyChoosedescription": "Conveniently located near Nagpur, Woodland Escape Resort is easily reachable by road, making it perfect for a quick one-day picnic trip. The scenic drive through natural landscapes sets the tone for a memorable outing, and upon arrival, you’re welcomed by the calming sights and sounds of the forest."
  }
]


  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort considered the best picnic spot near Nagpur?",
    answer: "Woodland Escape Resort is surrounded by lush greenery, scenic landscapes, and serene lakes, making it one of the best picnic spots near Nagpur. It’s perfect for families, friends, and groups looking to spend a fun-filled day amidst nature."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur?",
    answer: "The resort is conveniently located around 45 km from Nagpur, taking approximately 1 to 1.5 hours by road. It’s an easy and scenic drive, ideal for a quick picnic getaway from the city."
  },
  {
    question: "What facilities are available for picnics at the resort?",
    answer: "We offer spacious picnic areas, shaded seating spots, clean washrooms, and ample parking. Guests can also enjoy adventure activities, nature walks, boating, and access to our restaurant serving local delicacies."
  },
  {
    question: "Can we bring our own food for the picnic?",
    answer: "While outside food is not allowed for safety and hygiene reasons, our in-house kitchen serves fresh, delicious meals and snacks. You can pre-book picnic meal packages with a variety of vegetarian and non-vegetarian options."
  },
  {
    question: "Is Woodland Escape Resort suitable for school and corporate picnics?",
    answer: "Yes! We frequently host school trips, college picnics, and corporate outings. Our team can arrange customized activities, games, and meals to ensure everyone has a memorable experience."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort?",
    answer: "Booking your picnic is simple! You can call or WhatsApp our reservation team or visit our official website to fill out the booking form. Early booking is recommended, especially for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Rahul & Family, Nagpur",
    text: "Woodland Escape Resort is hands down the best picnic spot near Nagpur! The surroundings are peaceful, the staff is friendly, and the food was fantastic. We had an unforgettable day with our family and will definitely come back soon."
  },
  {
    name: "Miss. Kavita & Friends, Nagpur",
    text: "We planned a one-day picnic at Woodland Escape Resort and absolutely loved it! The nature views, adventure games, and tasty food made it a perfect outing. Highly recommended for anyone looking to relax and have fun near Nagpur."
  }
];

      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Picnic Spot Near Nagpur",
  "image": "https://woodlandescape.com/assets/images/best-picnic-spot-near-nagpur.jpg",
  "description": "Discover the best picnic spot near Nagpur at Woodlandescape Resort. Enjoy nature, adventure activities, lush green surroundings, and relaxing picnic areas perfect for families, couples, and corporate groups.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1284"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/best-picnic-spot-near-nagpur"
  }
};


  return (
    <div>
<Helmet>
  <title>Best Picnic Spot Near Nagpur | Family & Nature Retreat | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan your perfect picnic getaway at Woodlandescape Resort — the best picnic spot near Nagpur. Relax amidst nature, enjoy fun outdoor activities, and experience a refreshing day surrounded by greenery." 
  />
  <meta 
    name="keywords" 
    content="Best Picnic Spot Near Nagpur, Nagpur Top Picnic Places, Nagpur Picnic Locations, Family Picnic Spot Nagpur, Affordable Picnic Spot Nagpur, Nagpur Weekend Picnic, Nagpur Nature Picnic Spot, Nagpur Outdoor Picnic Place, Nagpur Scenic Picnic Spot, Nagpur Park Picnic Spot, Nagpur Hill Picnic Spot, Nagpur Riverside Picnic, Nagpur Garden Picnic, Nagpur Picnic Spot Booking, Nagpur Picnic Tour" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/2.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Bestpicnicspotnearnagpur;